export default "__VITE_ASSET__2Myk$8qZ__"